import { PwaDetails } from '@space-lib/datahub/enums'
import { UAParser } from 'ua-parser-js'

import { DataHubStore } from '../dataHubStore'

export abstract class BaseHomeSchema {
  private sessionId: string
  private clubVersion:
    | 'OLD_CLUB_MIDNIGHT'
    | 'OLD_CLUB_CLASSIC'
    | 'OLD_CLUB_MOBILE'
    | 'OLD_CLUB_ADMIN'
    | 'MEMBERSHIP'

  private url: string
  private screenName: string
  private platform: 'WEB' | 'IOS' | 'ANDROID'
  private platformDetail: string
  private appVersion: string
  private osVersion: string
  private ucode: string
  private userId: number
  private userRole: string
  private membershipId: string
  private membershipSlug: string
  private isLogged: boolean
  private hasAccess: boolean

  constructor() {
    const uaParser = new UAParser(navigator.userAgent)
    const browserInfo = uaParser.getBrowser()
    const isPwaSupported =
      (window.matchMedia?.(PwaDetails.DISPLAY_MODE_STANDALONE)?.matches &&
        document?.querySelector(PwaDetails.MANIFEST_ATTRIBUTE)) ||
      false
    const pwaStatus = isPwaSupported ? PwaDetails.ENABLE : PwaDetails.DISABLE
    const platformDetail = browserInfo?.name + pwaStatus

    this.sessionId = 'X'
    this.clubVersion = 'MEMBERSHIP'
    this.url = window.location.href
    this.screenName = 'NOT_APP_EVENT'
    this.platform = 'WEB'
    this.platformDetail = platformDetail ?? ''
    this.appVersion = DataHubStore.getAppVersion()
    this.osVersion = browserInfo.version ?? ''
    this.ucode = DataHubStore.getUcode()
    this.userId = DataHubStore.getUserId()
    this.userRole = DataHubStore.getUserRole()
    this.membershipId = DataHubStore.getMembershipId()
    this.membershipSlug = DataHubStore.getMembershipSlug()
    this.isLogged = DataHubStore.getIsLogged()
    this.hasAccess = DataHubStore.getIsLogged()
  }

  protected prepare() {
    return {
      sessionId: this.sessionId,
      clubVersion: this.clubVersion,
      url: this.url,
      screenName: this.screenName,
      platform: this.platform,
      platformDetail: this.platformDetail,
      appVersion: this.appVersion,
      osVersion: this.osVersion,
      ucode: this.ucode,
      userId: this.userId,
      userRole: this.userRole,
      membershipId: this.membershipId,
      membershipSlug: this.membershipSlug,
      isLogged: this.isLogged,
      hasAccess: this.hasAccess
    }
  }

  abstract getDataHubEventData(): Record<string, unknown>
}
